import { createAsyncThunk, createSlice, current } from "@reduxjs/toolkit";
import { getAxiosInstance } from "../../../api";

const initialState = {
  status: "idle",
  isOpen: false,
  paymentCancelStatus: "idle",
  selectedPlan: {},
  data: {
    isOpen: false,
    details: {},
    type:""
  },
  hdfc_payment: {},
  hdfc_status: "idel",
};
export const inititatePayment = createAsyncThunk(
  "payment/InititatePayment",
  async (params, { rejectWithValue }) => {
    const api = await getAxiosInstance();
    try {
      const response = await api.post(`payment/razorpay`, params);

      return response;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);
export const paymentCompletion = createAsyncThunk(
  "payment/paymentCompletion",
  async (params, { rejectWithValue }) => {
    const api = await getAxiosInstance();
    try {
      const response = await api.post("payment/razorpay-process", params);

      return response;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const hdfcPayment = createAsyncThunk(
  "payment/hdfcPayment",
  async (params, { rejectWithValue }) => {
    const api = await getAxiosInstance();
    try {
      const response = await api.post("payment/save-order", params);

      return response;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const HDFCPaymentStudio = createAsyncThunk(
  "payment/HDFCPaymentStudio",
  async (params, { rejectWithValue }) => {
    const api = await getAxiosInstance();
    try {
      const response = await api.post("payment/save-order", params);

      return response;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

const checkoutSlice = createSlice({
  name: "payment",
  initialState,
  reducers: {
    closeModal: (state, action) => {
      state.data = {};
    },
    paymentModalAction: (state, action) => {
      state.isOpen = action.payload?.isOpen;
      state.selectedPlan = action.payload?.item;
      state.data.type=action.payload?.type
    },
    updateConfig: (state, action) => {
      action.payload(state);
    },
  },

  extraReducers: {
    [inititatePayment.pending]: (state) => {
      state.status = "loading";
    },
    [inititatePayment.fulfilled]: (state, action) => {
      state.status = "success";
      state.data = {
        isOpen: true,
        details: action.payload.data.result,
        type:""
      };
    },
    [inititatePayment.rejected]: (state, action) => {
      state.status = "error";
    },
    
    [hdfcPayment.pending]: (state) => {
      state.hdfc_status = "loading";
    },

    [hdfcPayment.fulfilled]: (state, action) => {
      state.hdfc_payment = action.payload.data.result;
      state.hdfc_status = "success";
    },
    [hdfcPayment.rejected]: (state, action) => {
      state.hdfc_status = "error";
    },
  },
});

export const { closeModal, paymentModalAction,updateConfig } = checkoutSlice.actions;

export default checkoutSlice.reducer;
